import React from 'react';
import { motion } from 'framer-motion';
import { UserIcon } from './icons';
export function StoryCredibility() {
  return <section id="nosotros" className="py-12 bg-brand-bg-dark border-y border-brand-gold/10" data-id="element-283">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-284">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-285">
          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-286">
            <UserIcon className="w-10 h-10 text-brand-gold" data-id="element-287" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-288">
              La Historia de Geovanny
            </h2>
          </div>

          <div className="prose prose-lg prose-invert mx-auto" data-id="element-289">
            <p className="text-xl text-gray-300 leading-relaxed mb-8" data-id="element-290">
              Geovanny Benítez no empezó con una oficina grande ni con un equipo
              de 50 personas.
            </p>

            <p className="text-xl text-gray-300 leading-relaxed mb-10" data-id="element-291">
              Empezó con sus manos, sus herramientas, y una promesa simple:
            </p>

            <blockquote className="text-3xl sm:text-4xl font-heading font-bold text-brand-gold text-center my-8 py-6 border-y border-brand-gold/20 bg-brand-gold/5" data-id="element-292">
              "Si le doy mi palabra a alguien, lo cumplo."
            </blockquote>

            <p className="text-xl text-gray-300 leading-relaxed mb-8" data-id="element-293">
              Esa filosofía construyó{' '}
              <strong className="text-white font-heading tracking-wide" data-id="element-294">
                BENITEZ HANDYMAN CONSTRUCTION
              </strong>{' '}
              proyecto por proyecto, casa por casa, familia por familia en la
              región de DC, Maryland y Virginia.
            </p>

            <p className="text-xl text-gray-300 leading-relaxed" data-id="element-295">
              Hoy, después de años de trabajo en esta comunidad, nuestro nombre
              se pasa de boca en boca — no porque hagamos publicidad cara — sino
              porque{' '}
              <strong className="text-brand-gold" data-id="element-296">
                cada trabajo habla por sí mismo.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}